import React, { useState } from 'react';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import { useAuth } from './context/AuthContext';
import {currentUser,myUser,logout} from './context/AuthContext';
import isMobile from './components/tools/DeviceInfo';

export const AppProfile = () => {

    const [expanded, setExpanded] = useState(false);

    const onClick = (event) => {
        setExpanded(prevState => !prevState);
        event.preventDefault();
    }

    const [mierror, setMierror] = useState('');
    const {logout,myUser} = useAuth();

    // const handleClick = () =>{
    //     if( isMobile.any() ) {
    //         addClass(document.body, "body-overflow-hidden");
    //     }
    // }

    // const addClass = (element, className) => {
    //     if (element.classList){
    //     console.log ('add');
    //         element.classList.add(className);}
    //     else
    //         element.className += ' ' + className;
    // }

    const handleLogout = async () =>{
        try {
            // alert('ingreso');
            await logout();
        } catch (error) {
            setMierror('Error del Servidor');
        }

    };

    return (
        <div className="layout-profile">
            <div>
                <img src="assets/layout/images/avatar_4.png" alt="Profile" />
            </div>
            <button className="p-link layout-profile-link" onClick={onClick}>
                <span className="username">{myUser.nam}</span>
                <i className="pi pi-fw pi-cog" />
            </button>
            <CSSTransition classNames="p-toggleable-content" timeout={{ enter: 1000, exit: 450 }} in={expanded} unmountOnExit>
                <ul className={classNames({ 'layout-profile-expanded': expanded })}>
                    {/* <li><a href={'#/datos'} ><button type="button" className="p-link" onClick={handleClick}><i className='pi pi-fw pi-id-card' /><span>Datos Personales</span></button></a></li> */}
                    <li><button type="button" className="p-link" onClick= {handleLogout} ><i className="pi pi-fw pi-power-off"/><span>Salir</span></button></li>
                </ul>
            </CSSTransition>
        </div>
    );

}
